import React from "react";

const WarningAlert = () => (
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <circle cx="14" cy="14" r="14" fill="#FFEDE8" />
      <mask
        id="warningAlertMask0"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 6C9.584 6 6 9.584 6 14C6 18.416 9.584 22 14 22C18.416 22 22 18.416 22 14C22 9.584 18.416 6 14 6ZM14.8 18H13.2V16.4H14.8V18ZM14.8 14.8003H13.2V10.0003H14.8V14.8003Z"
          fill="white"
        />
      </mask>
      <g mask="url(#warningAlertMask0)">
        <rect
          x="-5.80052"
          y="-5.80026"
          width="40.2"
          height="40.2"
          fill="#E27A66"
        />
        <mask
          id="warningAlertMask1"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="-6"
          y="-6"
          width="41"
          height="41"
        >
          <rect
            x="-5.80052"
            y="-5.80026"
            width="40.2"
            height="40.2"
            fill="white"
          />
        </mask>
        <g mask="url(#warningAlertMask1)" />
      </g>
    </svg>
  </span>
);

export default WarningAlert;
